class SodRoutine extends HTMLElement {
  connectedCallback() {
    this.triggers = Array.from(this.querySelectorAll('.sod-routine__trigger'));
    this.descs = Array.from(this.querySelectorAll('.sod-routine__desc'));
    this.slides = Array.from(this.querySelectorAll('.sod-routine__slide'));
    this.tags = Array.from(this.querySelectorAll('.sod-routine__tag'));

    this.triggers.forEach((t) => t.addEventListener('click', this.onClick));
    this.addEventListener('keydown', this.onKey);
  }

  disconnectedCallback() {
    this.triggers.forEach((t) => t.removeEventListener('click', this.onClick));
    this.removeEventListener('keydown', this.onKey);
  }

  onClick = (event) => {
    this.open(Number(event.currentTarget.dataset.index));
  };

  onKey = (event) => {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    const at = this.triggers.indexOf(document.activeElement);
    if (at === -1) return;
    event.preventDefault();
    const step = event.key === 'ArrowRight' ? 1 : -1;
    const next = (at + step + this.triggers.length) % this.triggers.length;
    this.triggers[next].focus();
    this.open(next);
  };

  open(index) {
    this.triggers.forEach((t, i) => {
      const on = i === index;
      t.classList.toggle('is-open', on);
      t.setAttribute('aria-expanded', String(on));
    });

    const show = (nodes, attr) => {
      nodes.forEach((n) => { n.hidden = Number(n.dataset[attr]) !== index; });
    };
    show(this.descs, 'desc');
    show(this.slides, 'slide');
    show(this.tags, 'tag');
  }
}

if (!customElements.get('sod-routine')) {
  customElements.define('sod-routine', SodRoutine);
}
